import { getDateString } from '@utils/time.js';

export const createDatetimeString = (timestamp) => {
  return getDateString(timestamp, 'ru', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
};
